import React, { useState } from "react";
import ProjectsCard from "../components/ProjectsCard";
import Navbar from "../components/navbar/Navbar";
import "../styles/Projects.css";

const ProjectsPage = () => {
  const [nav, setNav] = useState(false);
  const handleNav = () => setNav(!nav);

  const projects = [
    {
      title: "Project 1",
      description:
        "A brief description of your first project. Explain what it does and what technologies you used.",
      technologies: ["React", "Node.js", "MongoDB"],
      link: "https://github.com/yourusername/project1",
    },
    {
      title: "Project 2",
      description:
        "Description of your second project. Highlight the key features and your role in development.",
      technologies: ["Python", "Django", "PostgreSQL"],
      link: "https://github.com/yourusername/project2",
    },
    {
      title: "Project 3",
      description:
        "Overview of your third project. Mention any interesting challenges you solved.",
      technologies: ["JavaScript", "Express", "MySQL"],
      link: "https://github.com/yourusername/project3",
    },
  ];

  return (
    <>
      <Navbar nav={nav} handleNav={handleNav} />
      <div className="projects-page">
        <div className="container">
          <div className="heading">
            <p className="heading-sub-text">My Work</p>
            <h2 className="heading-text">Projects</h2>
          </div>
          <div className="projects-grid">
            {projects.map((project, index) => (
              <ProjectsCard
                key={index}
                title={project.title}
                description={project.description}
                technologies={project.technologies}
                link={project.link}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectsPage;
